import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineEventFilters } from "@formant/core/common/combineFilters";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IFilter } from "@formant/core/model/IFilter";
import { severities } from "@formant/core/model/severities";
import { Severity } from "@formant/core/model/Severity";
import { severityIcons } from "@formant/ui/component/common/Icon";

import { eventStore } from "../../stores";
import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface ISeveritySelectProps {
    value: Severity[];
    filter?: IEventFilter;
    context?: IFilter;
    className?: string;
    onChange: (value: Severity[]) => void;
}

@observer
export class SeveritySelect extends Component<ISeveritySelectProps> {
    private severities: Severity[] = [];
    public render() {
        const { value, filter, context, className, onChange } = this.props;
        if (!filter || !context) {
            this.severities = [...severities];
        } else {
            this.severities =
                eventStore.severities(
                    combineEventFilters(context, {
                        ...filter,
                        severities: undefined,
                    }),
                ) || this.severities;
        }
        const s = this.severities;
        const options = allOptions.filter(
            ({ value: v }) => s.includes(v) || value.includes(v),
        );
        if (options.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && options.length === 1;

        return (
            <MultiSelect
                value={value}
                title="Severity"
                options={options}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}

const allOptions: IMultiSelectOption<Severity>[] = severities.map(severity => ({
    value: severity,
    label: severity,
    icon: severityIcons[severity],
}));
